import { render, staticRenderFns } from "./TrackAndTraceShare.vue?vue&type=template&id=ac522536"
import script from "./TrackAndTraceShare.vue?vue&type=script&lang=ts"
export * from "./TrackAndTraceShare.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports